import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import Skeleton from '@mui/material/Skeleton';
import Tooltip from '@mui/material/Tooltip';

export default function GpanelContactsLabelsItem({
  icon,
  label,
  disabledReason = '',
  count,
  selected,
  disabled,
  onClick,
  isLoading,
}: {
  icon?: React.ReactNode;
  label: string;
  disabledReason?: string;
  count?: number | null;
  selected: boolean;
  disabled?: boolean;
  isLoading?: boolean;
  onClick: (label: string) => void;
}) {
  if (isLoading) {
    return (
      <Skeleton
        variant="rounded"
        role="status"
        width="100%"
        height={44}
        sx={{
          borderRadius: 2,
          mb: 0.5,
        }}
      />
    );
  }

  return (
    <Tooltip arrow title={disabledReason}>
      <ListItem
        sx={{ py: 0, pr: 0, pl: 0 }}
        secondaryAction={
          typeof count === 'number' && (
            <Typography variant="body2" color="textSecondary">
              {count}
            </Typography>
          )
        }
      >
        <ListItemButton
          onClick={() => onClick(label)}
          selected={selected}
          disabled={disabled}
          sx={{
            borderRadius: 2,
            pl: 1,
          }}
        >
          <Stack sx={{ mr: 1 }}>{icon}</Stack>
          <ListItemText primary={label} />
        </ListItemButton>
      </ListItem>
    </Tooltip>
  );
}
